import React from 'react';

import { Typography } from '@occc-app/design-system';

export const PromocodeStats = (props: { redemptions: number; totalOfferRedemptions: number }) => {
  const { redemptions, totalOfferRedemptions } = props;
  const percentValue = (redemptions / (totalOfferRedemptions || 1)) * 100;

  return (
    <Typography variant='body2'>
      <Typography component='span' fontWeight='bold'>
        {`${percentValue.toFixed(2)}% `}
      </Typography>
      (
      <Typography component='span' fontWeight='bold'>
        {redemptions}
      </Typography>
      <Typography component='span'>/{totalOfferRedemptions}</Typography>)
    </Typography>
  );
};
